// Invariant 2: client-generated IDs. Every write is an upsert keyed on an ID
// the phone minted before the network was ever involved, so a retry — or five —
// can never create a second row.

/** UUID v4. crypto.randomUUID needs a secure context; keep a real fallback. */
export function uuid(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();

  const b = new Uint8Array(16);
  c.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40; // version 4
  b[8] = (b[8] & 0x3f) | 0x80; // variant 10
  const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${
    h.slice(16, 20)
  }-${h.slice(20)}`;
}

// guestCode / normalizeCode / isValidCode are gone with guest registration.
// The only two codes left are STANDA and STANDB: fixed literals seeded by
// migration 0009, held as constants in the console, never generated and never
// typed by anyone. A generator and a parser for them would be machinery
// guarding a value that cannot vary.
